import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/yield-to-maturity-calculator',
  component: () => import('../../routes/YieldToMaturityCalculator.svelte'),
  card: {
    id: 'yield-to-maturity',
    title: 'Yield to Maturity (YTM)',
    description: 'Calculate the total return anticipated on a bond if held until maturity, comparing yields across different prices and coupon rates.',
    icon: 'trending_up',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/yield-to-maturity-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Yield to Maturity (YTM) Calculator – Free Bond YTM Tool',
    description: 'Free YTM calculator estimates the total return on a bond if held to maturity. Compare bonds trading at discount, premium, or par.',
  },
};

export default meta;
